import { render, staticRenderFns } from "./ServiceRequestConsumerUnitMenu.vue?vue&type=template&id=5b680f5f&scoped=true"
import script from "./ServiceRequestConsumerUnitMenu.vue?vue&type=script&lang=js"
export * from "./ServiceRequestConsumerUnitMenu.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestConsumerUnitMenu.vue?vue&type=style&index=0&id=5b680f5f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b680f5f",
  null
  
)

export default component.exports